import { forwardRef, PropsWithChildren, UIEvent } from 'react';

interface IProps {
  onEndReached?: () => void;
}

export const ScrollArea = forwardRef<HTMLDivElement, PropsWithChildren<IProps>>(
  ({ children, onEndReached }, ref) => {
    const onScroll = (e: UIEvent<HTMLDivElement>) => {
      const target = e.currentTarget;
      const isAtBottom = Math.abs(target.scrollHeight - target.scrollTop - target.clientHeight) < 1;

      if (isAtBottom && onEndReached) {
        onEndReached();
      }
    };

    return (
      <div
        ref={ref}
        style={{
          overflow: 'auto',
          position: 'relative',
          width: '100%',
        }}
        onScroll={onScroll}
      >
        {children}
      </div>
    );
  },
);

ScrollArea.displayName = 'ScrollArea';
